import React from 'react'
import PropTypes from 'prop-types'
import {AddressAutoComplete} from "./AddressAutoComplete";
import {formatPostalAddress, requiredFields, validateAddress} from "./util";
import {CountrySelector} from "./CountrySelector";
import CountryStore from "./CountryStore";
import {Spinner} from "../../../components/index";
import {PropTypes as ObservablePropTypes} from 'mobx-react'

const textFields = [
  'addressLocality',
  'addressRegion',
  'postalCode',
  'streetAddress',
  'suite'
];

export class PostalAddressForm extends React.Component {

  static propTypes = {
    postalAddress: PropTypes.shape({
      addressCountry: PropTypes.string,
      addressLocality: PropTypes.string,
      addressRegion: PropTypes.string,
      postOfficeBoxNumber: PropTypes.string,
      postalCode: PropTypes.string,
      streetAddress: PropTypes.string,
      //
      suite: PropTypes.string // not part of the definition
    }).isRequired,

    /**
     * function with signature
     * (postalAddress: PostalAddress, isValid: boolean) => {}
     */
    onChange: PropTypes.func.isRequired,
    showAllErrors: PropTypes.bool,
    setValidity: PropTypes.func
  }

  state = {
    countryModel: undefined,
    countryModelResolving: true,
    touchedFields: [],
    errors: [],
    requiredFields: []
  }

  componentWillMount() {
    this.resolveCountry(this.props)
  }

  componentWillReceiveProps(nextProps, nextContext) {
    if (nextProps.postalAddress.addressCountry !== this.props.postalAddress.addressCountry) {
      this.resolveCountry(nextProps)
      this.revalidate(this.state.countryModel, nextProps.postalAddress)
    }
  }

  resolveCountry(props) {
    this.setState({ countryModelResolving: true })
    const country = (props.postalAddress.addressCountry || '').trim()

    let promise;
    if (!country) {
      promise = CountryStore.resolve("US")
    } else {
      promise = CountryStore.resolve(country.trim())
    }
    promise.then(c => {
      let model = c ? c : CountryStore.adhoc(country)
      this.setState({
        countryModel: model,
        requiredFields: requiredFields(model),
        countryModelResolving: false
      })
      if(!props.postalAddress.addressCountry) {
        props.postalAddress.addressCountry = model.name
      }
      this.revalidate(model, this.props.postalAddress)

    })
  }


  onAddressCountryChange = (country, fullSelection) => {
    this.onChangePostalAddress({ addressCountry: country && country.id }, this.state.errors)
  }

  onChangePostalAddress = (updates) => {
    const updatedPostalAddress = {...this.props.postalAddress, ...updates}
    this.revalidate(this.state.countryModel, updatedPostalAddress)
    this.props.onChange(updatedPostalAddress, this.state.errors)
  }

  revalidate(countryModel, postalAddress) {
    const invalid = validateAddress(countryModel, postalAddress)
    if (!_.isEqual(invalid, this.state.errors)) {
      this.setState({ errors: invalid })
    }
    if (this.props.setValidity) {
      this.props.setValidity(invalid)
    }
  }


  render() {
    const addr = this.props.postalAddress
    const {FormGroup, ValidatableInput} = this
    return <div>
      <div className="form-group row">
      <label className="col-sm-2 col-form-label text-sm-right">Address Search</label>
      <div className="col-sm-10">
        <AddressAutoComplete
          selected={undefined}
          onSelected={this.onChangePostalAddress}
          placeholder="Start typing an address to search"
        />
      </div>
      </div>
      <FormGroup
        label="Country"
        errLabel="Country is Required"
        field="addressCountry"
        flatCats
      ><CountrySelector
        selected={this.state.countryModel}
        addCustom
        required
        onSelected={this.onAddressCountryChange}/>
      </FormGroup>
      <FormGroup
        label="Street Address"
        errLabel="Street Address is Required"
        field="streetAddress"
      ><ValidatableInput field="streetAddress" maxLength="100"/></FormGroup>
      <FormGroup
        label="Suite"
        field="suite"
      ><ValidatableInput field="suite" maxLength="50"/></FormGroup>
      <FormGroup
        label="City"
        errLabel="City is Required"
        field="addressLocality"
      ><ValidatableInput field="addressLocality" maxLength="32"/></FormGroup>
      <FormGroup
        label="State/Province"
        errLabel="State/Province is Required"
        field="addressRegion"
      ><ValidatableInput field="addressRegion" maxLength="3"/></FormGroup>
      <FormGroup
        label="Postal Code"
        errLabel="Postal Code is Required"
        field="postalCode"
      ><ValidatableInput field="postalCode" maxLength="10"/></FormGroup>
    </div>
  }


  onChangeTextProp = textFields.reduce((hash, field) => {
    hash[field] = (e) => this.onChangePostalAddress({ [field]: e.target.value })
    return hash
  }, {})

  onBlurTextField = textFields.reduce((hash, field) => {
    hash[field] = () => this.setState({ touchedFields: _.uniq(this.state.touchedFields.concat(field)) })
    return hash
  }, {})

  ValidatableInput = ({ field, maxLength }) => {
    const addr = this.props.postalAddress
    return <input type="text" className="form-control"
                  name={field}
                  value={addr[field] || ''}
                  onChange={this.onChangeTextProp[field]}
                  onBlur={this.onBlurTextField[field]}
                  maxLength={maxLength}
    />
  }

  FormGroup = ({
    field,
    label,
    errLabel,
    children,
    flatCats
  }) => {
    const isErr = this.state.errors.indexOf(field) !== -1
    const shouldShow = this.props.showAllErrors || (this.state.touchedFields.indexOf(field) !== -1)
    const showErr = isErr && shouldShow
    const isRequired = this.state.requiredFields.indexOf(field) > -1
    return <div className={`form-group row ${showErr ? 'has-error' : ''}`}>
      <Label>{label}{isRequired && '*'}</Label>
      <Content flatCats={flatCats}>{children}{
        showErr && <div className="form-error" >{errLabel}</div>
      }</Content>
    </div>
  }

}

const Label = (props) => <label className="col-sm-2 col-form-label text-sm-right" {...props} />
const Content = ({flatCats, ...props}) => <div className="col-sm-10" {...props} />
